/**
 * Schriftfarbe auf einer Markenflaeche.
 *
 * Helle Marken brauchen dunkle Schrift, dunkle Marken helle. Fest verdrahtete
 * Werte funktionieren nur, solange alle Kunden eine helle Marke fuehren:
 * Schwarz auf dem Rot von Minicar Kassel ergibt 3,33:1 und liegt damit unter
 * dem WCAG-Minimum von 4,5:1 — Weiss auf einem Marken-Gelb ist genauso falsch.
 *
 * Einzige Quelle fuer diese Entscheidung. `theme.js` leitet daraus
 * `palette.*.contrastText` ab; Komponenten, die eine Markenfarbe direkt als
 * Hintergrund setzen (und damit an MUIs contrastText vorbeilaufen), holen sich
 * die Schriftfarbe hier.
 */

export const relativeLuminance = (hex) => {
  const c = hex.replace('#', '');
  const [r, g, b] = [0, 2, 4].map((i) => parseInt(c.substr(i, 2), 16) / 255);
  const f = (v) => (v <= 0.03928 ? v / 12.92 : ((v + 0.055) / 1.055) ** 2.4);
  return 0.2126 * f(r) + 0.7152 * f(g) + 0.0722 * f(b);
};

export const contrastOn = (hex) => (relativeLuminance(hex) > 0.4 ? '#000000' : '#FFFFFF');

export default contrastOn;
